// extracted by mini-css-extract-plugin
module.exports = {"text":"BodyLarge_text__ryDIB","textIndent":"BodyLarge_textIndent__ub9KQ"};